import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { SpaciousSemantic_getInstance49m8xgr9xadn as SpaciousSemantic_getInstance } from '../../theme/semantics.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Employer27b20p5x27kte as Employer } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name3gijmx3xstqlj as get_name,
  get_contacteqygr3gdfszq as get_contact,
  get_name1iemflb9d8z7b as get_name_0,
  get_emailbv7cfcsvgkdr as get_email,
  get_phone31swsuqbmo9e as get_phone,
  get_billingContactName2pajxzqwevsfd as get_billingContactName,
  get_billingAddress2jws2mkpoutb7 as get_billingAddress,
  get_line12qowz8aajkggm as get_line1,
  get_line22yru7ztqlgmow as get_line2,
  get_city182djzl8rp5cw as get_city,
  get_state1oesqq81882tl as get_state,
  get_postalCodeb3j2izx1u631 as get_postalCode,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  lensPath21i5dxhjzuxep as lensPath,
  lensPath3fz41zcs9wh0z as lensPath_0,
} from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import {
  withStringBufferw9sv07w4j3wo as withStringBuffer,
  withStringBuffer3khj76irczpue as withStringBuffer_0,
} from '../components/validation.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import {
  labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox,
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
} from '../components/view-utilities.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  shownWhen3t7othivfr11 as shownWhen,
  weight31wqab1913ly4 as weight,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Addresspdncepxooezp as Address } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { notNull1cr24slx2d4vw as notNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function employerForm(form, _this__u8e3s4, employer, showBillingAddress, withCards) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  if (!withCards) {
    element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SpaciousSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  var tmp = employerForm$lambda;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$12);
  var tmp$ret$13 = get_name(it);
  var tmp$ret$10 = lensPath(employer, tmp$ret$13);
  form.stringField$default_pwglgw_k$(element_0, tmp, assertNotBlank(tmp$ret$10), true);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_1.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_3 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_3, employerForm$lambda_0);
  element_2.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element_1.willAddChild_hz2iwc_k$(element_3);
  var tmp_4 = KMutableProperty0();
  var tmp_5 = LabeledView$_get_content_$ref_5yojet(element_3);
  var tmp_6 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, LabeledView$_set_content_$ref_ys1c8f(element_3));
  element_3.invoke_bnq13k_k$(tmp_6, employerForm$lambda_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_0 = themed(element_3, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextInput())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_0.willAddChild_hz2iwc_k$(element_4);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_7 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$32 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$32);
  var tmp$ret$33 = get_name_0(get_contact(it_0));
  var tmp$ret$30 = lensPath(employer, tmp$ret$33);
  element_4.bind_gesskf_k$(element_4.content_1, tmp$ret$30);
  element_4.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_4);
  element_3.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element_1.willAddChild_hz2iwc_k$(element_5);
  var tmp_8 = KMutableProperty0();
  var tmp_9 = LabeledView$_get_content_$ref_5yojet(element_5);
  var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, LabeledView$_set_content_$ref_ys1c8f(element_5));
  element_5.invoke_bnq13k_k$(tmp_10, employerForm$lambda_2);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_1 = themed(element_5, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (TextInput())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_1.willAddChild_hz2iwc_k$(element_6);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$43 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$43);
  var tmp$ret$44 = get_email(get_contact(it_1));
  var tmp$ret$41 = lensPath(employer, tmp$ret$44);
  element_6.bind_gesskf_k$(element_6.content_1, withStringBuffer(validated(tmp$ret$41)));
  element_6.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_6);
  element_5.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_5);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  element_1.willAddChild_hz2iwc_k$(element_7);
  var tmp_12 = KMutableProperty0();
  var tmp_13 = LabeledView$_get_content_$ref_5yojet(element_7);
  var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, LabeledView$_set_content_$ref_ys1c8f(element_7));
  element_7.invoke_bnq13k_k$(tmp_14, employerForm$lambda_3);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
  var this_2 = themed(element_7, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = PhoneNumberInput().new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_w1yrw4_k$(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  this_2.willAddChild_hz2iwc_k$(element_8);
  var tmp_15 = element_8.get_content_h02jrk_k$();
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_16 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$54 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$54);
  var tmp$ret$55 = get_phone(get_contact(it_2));
  var tmp$ret$52 = lensPath(employer, tmp$ret$55);
  element_8.bind_gesskf_k$(tmp_15, withStringBuffer_0(validated(tmp$ret$52)));
  element_8.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_8);
  element_7.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_7);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  element.willAddChild_hz2iwc_k$(element_9);
  element_9.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_9.set_themeChoice_py59um_k$(element_9.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = new (TextView())(element_9.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  element_9.willAddChild_hz2iwc_k$(element_10);
  element_10.set_themeChoice_py59um_k$(element_10.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_17 = KMutableProperty0();
  var tmp_18 = TextView$_get_content_$ref_4pzcwl(element_10);
  var tmp_19 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb(element_10));
  element_10.invoke_bnq13k_k$(tmp_19, employerForm$lambda_4);
  element_10.onStartup_vrxh3i_k$();
  element_9.addChild_2qpft2_k$(element_10);
  labeledCheckbox(element_9, employerForm$lambda_5, showBillingAddress);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_3 = shownWhen(element_9, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(showBillingAddress));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_11 = new (RowOrCol())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_11);
  this_3.willAddChild_hz2iwc_k$(element_11);
  element_11.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_12 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_11.get_context_h02k06_k$());
  ensureOutermostElement(element_12);
  element_11.willAddChild_hz2iwc_k$(element_12);
  var tmp_20 = KMutableProperty0();
  var tmp_21 = LabeledView$_get_content_$ref_5yojet(element_12);
  var tmp_22 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, LabeledView$_set_content_$ref_ys1c8f(element_12));
  element_12.invoke_bnq13k_k$(tmp_22, employerForm$lambda_6);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_4 = themed(element_12, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_13 = new (TextInput())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_13);
  this_4.willAddChild_hz2iwc_k$(element_13);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_23 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$78 = isInterface(tmp_23, KSerializer()) ? tmp_23 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$78);
  var tmp$ret$79 = get_billingContactName(it_3);
  var tmp$ret$76 = lensPath(employer, tmp$ret$79);
  element_13.bind_gesskf_k$(element_13.content_1, tmp$ret$76);
  element_13.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_13);
  element_12.onStartup_vrxh3i_k$();
  element_11.addChild_2qpft2_k$(element_12);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_24 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$82 = isInterface(tmp_24, KSerializer()) ? tmp_24 : THROW_CCE();
  var it_4 = new (DataClassPathSelf())(tmp$ret$82);
  var tmp$ret$83 = get_billingAddress(it_4);
  var tmp$ret$80 = lensPath(employer, tmp$ret$83);
  var billingAddress = notNull(tmp$ret$80, new (Address())('', VOID, '', ''));
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_14 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_11.get_context_h02k06_k$());
  ensureOutermostElement(element_14);
  element_11.willAddChild_hz2iwc_k$(element_14);
  var tmp_25 = KMutableProperty0();
  var tmp_26 = LabeledView$_get_content_$ref_5yojet(element_14);
  var tmp_27 = getPropertyCallableRef('content', 0, tmp_25, tmp_26, LabeledView$_set_content_$ref_ys1c8f(element_14));
  element_14.invoke_bnq13k_k$(tmp_27, employerForm$lambda_7);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_5 = themed(element_14, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_15 = new (TextInput())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_15);
  this_5.willAddChild_hz2iwc_k$(element_15);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_28 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$93 = isInterface(tmp_28, KSerializer()) ? tmp_28 : THROW_CCE();
  var it_5 = new (DataClassPathSelf())(tmp$ret$93);
  var tmp$ret$94 = get_line1(it_5);
  var tmp$ret$91 = lensPath_0(billingAddress, tmp$ret$94);
  element_15.bind_gesskf_k$(element_15.content_1, tmp$ret$91);
  element_15.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_15);
  element_14.onStartup_vrxh3i_k$();
  element_11.addChild_2qpft2_k$(element_14);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_16 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_11.get_context_h02k06_k$());
  ensureOutermostElement(element_16);
  element_11.willAddChild_hz2iwc_k$(element_16);
  var tmp_29 = KMutableProperty0();
  var tmp_30 = LabeledView$_get_content_$ref_5yojet(element_16);
  var tmp_31 = getPropertyCallableRef('content', 0, tmp_29, tmp_30, LabeledView$_set_content_$ref_ys1c8f(element_16));
  element_16.invoke_bnq13k_k$(tmp_31, employerForm$lambda_8);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_6 = themed(element_16, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_17 = new (TextInput())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_17);
  this_6.willAddChild_hz2iwc_k$(element_17);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_32 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$104 = isInterface(tmp_32, KSerializer()) ? tmp_32 : THROW_CCE();
  var it_6 = new (DataClassPathSelf())(tmp$ret$104);
  var tmp$ret$105 = get_line2(it_6);
  var tmp$ret$102 = lensPath_0(billingAddress, tmp$ret$105);
  element_17.bind_gesskf_k$(element_17.content_1, tmp$ret$102);
  element_17.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_17);
  element_16.onStartup_vrxh3i_k$();
  element_11.addChild_2qpft2_k$(element_16);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_18 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_11.get_context_h02k06_k$());
  ensureOutermostElement(element_18);
  element_11.willAddChild_hz2iwc_k$(element_18);
  var tmp_33 = KMutableProperty0();
  var tmp_34 = LabeledView$_get_content_$ref_5yojet(element_18);
  var tmp_35 = getPropertyCallableRef('content', 0, tmp_33, tmp_34, LabeledView$_set_content_$ref_ys1c8f(element_18));
  element_18.invoke_bnq13k_k$(tmp_35, employerForm$lambda_9);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_7 = themed(element_18, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_19 = new (TextInput())(this_7.get_context_h02k06_k$());
  ensureOutermostElement(element_19);
  this_7.willAddChild_hz2iwc_k$(element_19);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_36 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$115 = isInterface(tmp_36, KSerializer()) ? tmp_36 : THROW_CCE();
  var it_7 = new (DataClassPathSelf())(tmp$ret$115);
  var tmp$ret$116 = get_city(it_7);
  var tmp$ret$113 = lensPath_0(billingAddress, tmp$ret$116);
  element_19.bind_gesskf_k$(element_19.content_1, tmp$ret$113);
  element_19.onStartup_vrxh3i_k$();
  this_7.addChild_2qpft2_k$(element_19);
  element_18.onStartup_vrxh3i_k$();
  element_11.addChild_2qpft2_k$(element_18);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_20 = new (RowOrCol())(element_11.get_context_h02k06_k$());
  ensureOutermostElement(element_20);
  element_11.willAddChild_hz2iwc_k$(element_20);
  element_20.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_8 = weight(element_20, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_21 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_8.get_context_h02k06_k$());
  ensureOutermostElement(element_21);
  this_8.willAddChild_hz2iwc_k$(element_21);
  var tmp_37 = KMutableProperty0();
  var tmp_38 = LabeledView$_get_content_$ref_5yojet(element_21);
  var tmp_39 = getPropertyCallableRef('content', 0, tmp_37, tmp_38, LabeledView$_set_content_$ref_ys1c8f(element_21));
  element_21.invoke_bnq13k_k$(tmp_39, employerForm$lambda_10);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_9 = themed(element_21, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_22 = new (TextInput())(this_9.get_context_h02k06_k$());
  ensureOutermostElement(element_22);
  this_9.willAddChild_hz2iwc_k$(element_22);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_40 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$131 = isInterface(tmp_40, KSerializer()) ? tmp_40 : THROW_CCE();
  var it_8 = new (DataClassPathSelf())(tmp$ret$131);
  var tmp$ret$132 = get_state(it_8);
  var tmp$ret$129 = lensPath_0(billingAddress, tmp$ret$132);
  element_22.bind_gesskf_k$(element_22.content_1, tmp$ret$129);
  element_22.onStartup_vrxh3i_k$();
  this_9.addChild_2qpft2_k$(element_22);
  element_21.onStartup_vrxh3i_k$();
  this_8.addChild_2qpft2_k$(element_21);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_10 = weight(element_20, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_23 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_10.get_context_h02k06_k$());
  ensureOutermostElement(element_23);
  this_10.willAddChild_hz2iwc_k$(element_23);
  var tmp_41 = KMutableProperty0();
  var tmp_42 = LabeledView$_get_content_$ref_5yojet(element_23);
  var tmp_43 = getPropertyCallableRef('content', 0, tmp_41, tmp_42, LabeledView$_set_content_$ref_ys1c8f(element_23));
  element_23.invoke_bnq13k_k$(tmp_43, employerForm$lambda_11);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_11 = themed(element_23, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_24 = new (TextInput())(this_11.get_context_h02k06_k$());
  ensureOutermostElement(element_24);
  this_11.willAddChild_hz2iwc_k$(element_24);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_44 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$143 = isInterface(tmp_44, KSerializer()) ? tmp_44 : THROW_CCE();
  var it_9 = new (DataClassPathSelf())(tmp$ret$143);
  var tmp$ret$144 = get_postalCode(it_9);
  var tmp$ret$141 = lensPath_0(billingAddress, tmp$ret$144);
  element_24.bind_gesskf_k$(element_24.content_1, tmp$ret$141);
  element_24.onStartup_vrxh3i_k$();
  this_11.addChild_2qpft2_k$(element_24);
  element_23.onStartup_vrxh3i_k$();
  this_10.addChild_2qpft2_k$(element_23);
  element_20.onStartup_vrxh3i_k$();
  element_11.addChild_2qpft2_k$(element_20);
  element_11.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_11);
  element_9.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_9);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function addEmployerDialog(form, _this__u8e3s4, employer, showBillingAddress, clearDraft) {
  // Inline function 'kotlin.with' call
  var $this$with = form;
  dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, addEmployerDialog$lambda$lambda);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    employerForm($this$with, element, employer, showBillingAddress, false);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(element_2, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
    element_4.invoke_bnq13k_k$(tmp_4, addEmployerDialog$lambda$lambda_0);
    element_4.onStartup_vrxh3i_k$();
    element_3.addChild_2qpft2_k$(element_4);
    onClick(element_3, VOID, VOID, VOID, addEmployerDialog$lambda$slambda(employer, close));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_2 = weight(element_2, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Space())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_3 = themed(element_2, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(this_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_4.willAddChild_hz2iwc_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element_6.willAddChild_hz2iwc_k$(element_7);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_7);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_7));
    element_7.invoke_bnq13k_k$(tmp_7, addEmployerDialog$lambda$lambda_1);
    element_7.onStartup_vrxh3i_k$();
    element_6.addChild_2qpft2_k$(element_7);
    element_6.set_action_2ds022_k$(Action('Add employer', VOID, VOID, VOID, VOID, VOID, addEmployerDialog$lambda$slambda_0(employer, $this$with, showBillingAddress, element_6, close, clearDraft)));
    element_6.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_6);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return Unit_instance;
}
function employerForm$lambda($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerNameLabel_rr9lvp_k$();
}
function employerForm$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerContactLabel_f0mfyw_k$();
}
function employerForm$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerContactNameLabel_h6hpwz_k$();
}
function employerForm$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerContactEmailLabel_245yvo_k$();
}
function employerForm$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerContactPhoneLabel_l68pj6_k$();
}
function employerForm$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerBillingAddressLabel_ppg2x_k$();
}
function employerForm$lambda_5($this$labeledCheckbox) {
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerAddBillingAddressLabel_f9xuim_k$();
}
function employerForm$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerBillingContactNameLabel_2furfk_k$();
}
function employerForm$lambda_7($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerStreetAddressLabel_hfp9k7_k$();
}
function employerForm$lambda_8($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerAptSuiteLabel_72k85f_k$();
}
function employerForm$lambda_9($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerCityLabel_axyh97_k$();
}
function employerForm$lambda_10($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerStateLabel_k0y83r_k$();
}
function employerForm$lambda_11($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerZipcodeLabel_ioxwh6_k$();
}
function addEmployerDialog$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerAddDialogHeading_48gd0j_k$();
}
function addEmployerDialog$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function addEmployerDialog$lambda$slambda($employer, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $employer.cancel_2l89ey_k$();
    $close();
    return Unit_instance;
  }), 0);
}
function addEmployerDialog$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerAddButton_d87ox_k$();
}
function addEmployerDialog$lambda$slambda_0($employer, $$this$with, $showBillingAddress, $$this$button, $close, $clearDraft) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues($employer);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* $$this$with.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      return Unit_instance;
    }
    var tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $showBillingAddress;
    if (!(yield* await_0(this_1, $completion))) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $employer;
      var tmp$ret$3 = yield* await_0(this_2, $completion);
      tmp_0 = yield* $employer.set_revjhg_k$(tmp$ret$3.copy$default_g0qldq_k$(VOID, VOID, VOID, null, ''), $completion);
    }
    var saved = yield* $employer.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_currentSessionNotNull();
    yield* (yield* await_0(this_3, $completion)).get_employers_iw3lox_k$().add_co22jy_k$(saved, $completion);
    var tmp_1 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$5 = yield* await_1(this_4, $completion);
    toast(tmp_1, tmp$ret$5.get_employerAddedToast_3ffj9x_k$());
    $close();
    yield* $($clearDraft($completion), $completion);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  addEmployerDialog as addEmployerDialog2fq6psrmn58a0,
  employerForm as employerForm2hm4gvzd0jfg8,
};
//endregion

//# sourceMappingURL=employerComponents.mjs.map
